import React, { useEffect, useState, useRef } from 'react';
import './IdeasLibertadTod.css';
import { blog12 } from '../../assets/data/12Blog';
import { useCounter } from '../../hooks/useCounter';
import { useTranslation } from "react-i18next";
import { useAxios } from '../../hooks/useAxios';

import rel from '../../assets/img/relo.png';

const IdeasLibertadTod = () => {
    const [t, i18n] = useTranslation("ideas_libertad");

    const { counter, increment, decrement, resetCounter, defaultValue } = useCounter(0);
    const [url, setUrl] = useState(`/blogs/n?offset=${counter}&next=12&lang=${i18n.language}`);

    const { data, isLoading, error } = useAxios(url);
    const [blogs, setBlogs] = useState([]);

    const formatDate = (date) => {
        const options = { day: "numeric", month: "long", year: "numeric" };
        return new Date(date).toLocaleDateString(i18n.language, options);

    };
    //Lenguaje

    const fecha = new Date(); // Obtén la fecha actual o la fecha que deseas formatear
    const opciones = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' };
    const fechaFormateada = fecha.toLocaleDateString('en-US', opciones);

    const numero = (txtresumen) => {
        // Verificar si txtresumen es una cadena y no es undefined
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            // Realizar split por "||"
            const partes = txtresumen.split("||");
    
            // Verificar si hay una segunda parte
            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim(); // Si hay una segunda parte, retornarla
            }
        }
        
        // Si no hay una segunda parte o si txtresumen no es una cadena o es vacío,
        // realizar el cálculo actual
        const i = Math.floor(Math.random() * 5) + 1;
        return i;
      };
    
      const resumensplit = (txtresumen) => {
        // Verificar si txtresumen es una cadena y no es undefined
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            // Realizar split por "||"
            const partes = txtresumen.split("||");
    
            // Verificar si hay una segunda parte
            if (partes.length > 1 && partes[0].trim() !== "") {
                return partes[0].trim(); // Si hay una segunda parte, retornarla
            }
        }
        
        return txtresumen;
      };


    useEffect(() => {
        if (data) {
            setBlogs(data);
        }
    }, [data]);

    useEffect(() => {
        setUrl(`/blogs/n?offset=${counter}&next=600&lang=${i18n.language}`);
    }, [counter, i18n.language])


    return (
        <>
            {
                (isLoading) ?
                    (<h1> Cargando... </h1>) :
                    (
                        <>
                            <div className="ILT_contenedor_LisBlog escritorio">
                                <div className="ILT_row1_LB">
                                    <p className="ILT_result">{(t('filtro.mostrar-resultados1'))} {data.length} {(t('filtro.mostrar-resultados2'))}</p>
                                </div>

                                <div className="ILT_row2_LB">
                                    <div className="ILT_list_content--items">
                                        {
                                            blogs.map((item, index) => (
                                                <div key={index} className="ILT_card">
                                                    <div className="ILT_front">
                                                        <img className="ILT_imgG_LB" src={item.urlImagen} alt={item.urlImagen} />
                                                        <div className="ILT_cinta">
                                                            <p className="ILT_tit_LB">{item.titulo}</p>
                                                        </div>
                                                    </div>

                                                    <div className="ILT_back">
                                                        <p className="ILT_fh_LB"> {formatDate(item.fecha)}  </p>
                                                        <p className="ILT_catego">
                                                            {
                                                                item.categorias.map(dat => dat.nombre).join(' | ')
                                                            }
                                                        </p>
                                                        <hr className="ILT_line_LB"></hr>
                                                        <p className="ILT_titu_LB">{item.titulo}
                                                        </p>
                                                        <p className="ILT_desc_LB">{resumensplit(item.resumen).substring(0, 110) + '...'}
                                                        </p>
                                                        <img className="ILT_reloj_LB " src={rel} alt="reloj"></img>
                                                        <p className="ILT_alineIzq_ub_LB"> {numero(item.resumen)} {(t('filtro.tiempo-lectura'))}</p>
                                                        <div className="ILT_div_bot_LB">

                                                            <a className="ILT_buton_LB" href={"/blog/" + item.tag}>{(t('filtro.leer'))}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>

                                </div>
                                <div className="ILT_row3_LB">
                                    <p className="ILT_result">{(t('filtro.mostrar-resultados1'))} {data.length} {(t('filtro.mostrar-resultados2'))}</p>
                                </div>
                            </div>
                            <div className="ILT_contenedor_LisBlog movil">
                                <div className="ILT_row1_LB">
                                    <p className="ILT_result">{(t('filtro.mostrar-resultados1'))} {data.length} {(t('filtro.mostrar-resultados2'))}</p>
                                </div>
                                <div className="ILT_row2_LB">
                                    <div className="ILT_list_content--items">
                                        {
                                            blogs.map((item, index) => (

                                                <div key={index} className="ILT_card">
                                                    <div className="ILT_front">
                                                        <img className="ILT_imgG_LB" src={item.urlImagen} alt={item.urlImagen} />
                                                        <div className="ILT_cinta">
                                                            <p className="ILT_tit_LB">{item.titulo}</p>
                                                        </div>
                                                    </div>

                                                    <div className="ILT_back">
                                                        <p className="ILT_fh_LB"> {formatDate(item.fecha)}  </p>
                                                        <p className="ILT_catego">
                                                            {
                                                                item.categorias.map(dat => dat.nombre).join(' | ')
                                                            }
                                                        </p>
                                                        <hr className="ILT_line_LB"></hr>
                                                        <p className="ILT_titu_LB">{item.titulo}
                                                        </p>
                                                        <p className="ILT_desc_LB">{resumensplit(item.resumen).substring(0, 110) + '...'}
                                                        </p>
                                                        <img className="ILT_reloj_LB " src={rel} alt="reloj"></img>
                                                        <p className="ILT_alineIzq_ub_LB"> {numero(item.resumen)} {(t('filtro.tiempo-lectura'))}</p>
                                                        <div className="ILT_div_bot_LB">
                                                            <a className="ILT_buton_LB" href={"/blog/" + item.tag}>{(t('filtro.leer'))}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className="ILT_row3_LB">
                                    <p className="ILT_result">{(t('filtro.mostrar-resultados1'))} {data.length} {(t('filtro.mostrar-resultados2'))}</p>
                                </div>
                            </div>
                        </>
                    )
            }
        </>
    );
}
export default IdeasLibertadTod;